var aviso_s_m = localStorage.getItem("aviso_sonoro_mensagem");
var aviso_s_i = localStorage.getItem("aviso_sonoro_interacao");
var aviso_s_c = localStorage.getItem("aviso_sonoro_chamada");
aviso_s_m = aviso_s_m === "true" ? true : aviso_s_m === "false" ? false : true;
aviso_s_i = aviso_s_i === "true" ? true : aviso_s_i === "false" ? false : true;
aviso_s_c = aviso_s_c === "true" ? true : aviso_s_c === "false" ? false : true;

module.exports = {
  meses: [
    "Janeiro",
    "01",
    "Fevereiro",
    "02",
    "Março",
    "03",
    "Abril",
    "04",
    "Maio",
    "05",
    "Junho",
    "06",
    "Julho",
    "07",
    "Agosto",
    "08",
    "Setembro",
    "09",
    "Outubro",
    "10",
    "Novembro",
    "11",
    "Dezembro",
    "12",
  ],
  aviso_sonoro_interacao: aviso_s_i,
  aviso_sonoro_mensagem: aviso_s_m,
  aviso_sonoro_chamada: aviso_s_c,
  tela_atual_ingweb: localStorage.getItem("tela_atual_ingweb") || "Clientes",
  // Antigo default do filtro de fila
  // filtro_fila: localStorage.getItem("clients_queue_status")
  //   ? localStorage.getItem("clients_queue_status").split(",")
  //   : ["0", "1", "2"],
  filtro_fila: localStorage.getItem("clients_queue_status")
    ? localStorage.getItem("clients_queue_status").split(",")
    : ["1"],
  fila_checkbox_callback:
    localStorage.getItem("fila_checkbox_callback") || true,
  fila_checkbox_espera: localStorage.getItem("fila_checkbox_espera") || true,
  fila_checkbox_em_tratamento:
    localStorage.getItem("fila_checkbox_em_tratamento") || true,
  fila_checkbox_retorno: localStorage.getItem("fila_checkbox_retorno") || true,
  info_login: localStorage.getItem("info_login") || "useroff",
  voz: true,
  whatsapp: true,
  telegram: true,
  facebook: true,
  webchat: true,
  instagram: true,
  twiiter: true,
  forward: true,
  emoji: true,
  time_alert_queue: 60000,
  log_full_ingenium: true,
};
